// Data fetch from https://docs.google.com/spreadsheets/d/1plJEBnYvCjSEM-rZjb87tS0tlyWCdSWweT3KOcvcwKk/edit#gid=0
const badWords = [
  "aardappels afgieteng",
  "achter het raam zitten",
  "afberen",
  "aflebberen",
  "afrossen",
  "afrukken",
  "aftrekken",
  "afwerkplaats",
  "afzeiken",
  "afzuigen",
  "anderhalve man en een paardekop",
  "anita",
  "asbak",
  "bagger schijten",
  "balen",
  "bedonderen",
  "befborstelg",
  "beffen",
  "bekken",
  "belazeren",
  "besodemieterd zijn",
  "besodemieteren",
  "beurt",
  "boemelen",
  "boerelul",
  "boerenpummelg",
  "bokkelul",
  "botergeil",
  "broekhoesten",
  "brugpieperg",
  "buffelen",
  "buiten de pot piesen",
  "da's kloten van de bok",
  "de ballen",
  "de hoer spelen",
  "de hond uitlaten",
  "de koffer induiken",
  "delg",
  "de pijp aan maarten geven",
  "de pijp uitgaan",
  "dombo",
  "draaikontg",
  "driehoog achter wonen",
  "drolg",
  "drooggeiler",
  "droogkloot",
  "een beurt geven",
  "een nummertje maken",
  "een wip maken",
  "eikel",
  "engerd",
  "flamoes",
  "flikken",
  "flikker",
  "gadverdamme",
  "galbak",
  "gedoogzone",
  "geilneef",
  "gesodemieter",
  "godverdomme",
  "graftak",
  "gras maaien",
  "gratenkutg",
  "greppeldel",
  "hoempert",
  "hoer",
  "hoerenbuurt",
  "hoerenloper",
  "hoerig",
  "hufter",
  "huisdealer",
  "johny",
  "kanen",
  "kettingzeugg",
  "klaarkomen",
  "klerebeer",
  "klooien",
  "klootjesvolk",
  "klootoog",
  "klootzak",
  "kloten",
  "kontg",
  "kontneuken",
  "krentekakker",
  "kuttelikkertje",
  "kwakkieg",
  "liefdesgrot",
  "lul-de-behanger",
  "lulhannes",
  "lummel",
  "mafketel",
  "matennaaierg",
  "matje",
  "mutsg",
  "naaien",
  "naakt",
  "neuken",
  "neukstier",
  "oetlul",
  "opgeilen",
  "opkankeren",
  "oprotten",
  "opsodemieteren",
  "op z'n hondjes",
  "op z'n sodemieter geven",
  "opzouten",
  "ouwehoer",
  "ouwehoeren",
  "ouwe rukker",
  "paardelul",
  "penozeg",
  "piesen",
  "piemel",
  "pijpbekkieg",
  "pijpen",
  "pleurislaaier",
  "poepen",
  "portiekslet",
  "potverdorie",
  "publiciteitsgeil",
  "raaskallen",
  "reetridder",
  "reet trappen, voor zijn",
  "remsporeng",
  "reutelen",
  "rothoer",
  "rotzak",
  "rukhond",
  "rukken",
  "schatje",
  "schijt",
  "schijten",
  "schoft",
  "schuinsmarcheerder",
  "shit",
  "slempen",
  "sletg",
  "sletterig",
  "slik mijn zaad",
  "snolg",
  "spuiten",
  "standje",
  "standje-69g",
  "stoephoer",
  "stootje",
  "strontg",
  "sufferdg",
  "tapijtnek",
  "teefg",
  "temeier",
  "teringlijer",
  "toeter",
  "tongzoeng",
  "triootjeg",
  "trottoir prostituée",
  "trottoirteef",
  "vergallen",
  "verkloten",
  "verneuken",
  "viespeuk",
  "vingeren",
  "vleesroos",
  "voor jan lul",
  "voor jan-met-de-korte-achternaam",
  "watje",
  "welzijnsmafia",
  "wippen",
  "wuftje",
  "zaadje",
  "zakkenwasser",
  "zeiken",
  "zeiker",
  "zuigen",
  "zuiplap",
  "2g1c",
  "2 girls 1 cup",
  "acrotomophilia",
  "alabama hot pocket",
  "alaskan pipeline",
  "anal",
  "anilingus",
  "anus",
  "apeshit",
  "arsehole",
  "ass",
  "asshole",
  "assmunch",
  "auto erotic",
  "autoerotic",
  "babeland",
  "baby batter",
  "baby juice",
  "ball gag",
  "ball gravy",
  "ball kicking",
  "ball licking",
  "ball sack",
  "ball sucking",
  "bangbros",
  "bareback",
  "barely legal",
  "barenaked",
  "bastard",
  "bastardo",
  "bastinado",
  "beaner",
  "beaners",
  "beaver cleaver",
  "beaver lips",
  "bestiality",
  "big black",
  "big breasts",
  "big knockers",
  "big tits",
  "bimbos",
  "birdlock",
  "bitches",
  "black cock",
  "blonde action",
  "blonde on blonde action",
  "blowjob",
  "blow job",
  "blow your load",
  "blue waffle",
  "blumpkin",
  "bollocks",
  "bondage",
  "boner",
  "boob",
  "boobs",
  "booty call",
  "brown showers",
  "brunette action",
  "bukkake",
  "bulldyke",
  "bullet vibe",
  "bullshit",
  "bung hole",
  "bunghole",
  "busty",
  "buttcheeks",
  "butthole",
  "camel toe",
  "camgirl",
  "camslut",
  "camwhore",
  "carpet muncher",
  "carpetmuncher",
  "chocolate rosebuds",
  "circlejerk",
  "cleveland steamer",
  "clitoris",
  "clover clamps",
  "clusterfuck",
  "cock",
  "cocks",
  "coprolagnia",
  "coprophilia",
  "cornhole",
  "coon",
  "coons",
  "creampie",
  "cumming",
  "cunnilingus",
  "cunt",
  "darkie",
  "date rape",
  "daterape",
  "deep throat",
  "deepthroat",
  "dendrophilia",
  "dildo",
  "dingleberry",
  "dingleberries",
  "dirty pillows",
  "dirty sanchez",
  "doggie style",
  "doggiestyle",
  "doggy style",
  "doggystyle",
  "dog style",
  "dolcett",
  "domination",
  "dominatrix",
  "dommes",
  "donkey punch",
  "double dong",
  "double penetration",
  "dp action",
  "dry hump",
  "eat my ass",
  "ecchi",
  "ejaculation",
  "erotic",
  "erotism",
  "escort",
  "eunuch",
  "faggot",
  "fecal",
  "fellatio",
  "feltch",
  "female squirting",
  "femdom",
  "figging",
  "fingerbang",
  "fingering",
  "fisting",
  "foot fetish",
  "footjob",
  "frotting",
  "fuck",
  "fuck buttons",
  "fuckin",
  "fucking",
  "fucktards",
  "fudge packer",
  "fudgepacker",
  "futanari",
  "gang bang",
  "gay sex",
  "genitals",
  "giant cock",
  "girl on top",
  "girls gone wild",
  "goatcx",
  "goatse",
  "god damn",
  "gokkun",
  "golden shower",
  "goodpoop",
  "goo girl",
  "goregasm",
  "grope",
  "group sex",
  "g-spot",
  "hand job",
  "handjob",
  "hard core",
  "hardcore",
  "hentai",
  "homoerotic",
  "honkey",
  "hooker",
  "hot carl",
  "hot chick",
  "how to kill",
  "how to murder",
  "huge fat",
  "humping",
  "incest",
  "intercourse",
  "jack off",
  "jail bait",
  "jailbait",
  "jelly donut",
  "jerk off",
  "jigaboo",
  "jiggaboo",
  "jiggerboo",
  "jizz",
  "juggs",
  "kike",
  "kinbaku",
  "kinkster",
  "kinky",
  "knobbing",
  "leather restraint",
  "leather straight jacket",
  "lemon party",
  "lolita",
  "lovemaking",
  "make me come",
  "male squirting",
  "masturbate",
  "menage a trois",
  "milf",
  "missionary position",
  "motherfucker",
  "mound of venus",
  "mr hands",
  "muff diver",
  "muffdiving",
  "nambla",
  "nawashi",
  "negro",
  "neonazi",
  "nigga",
  "nigger",
  "nig nog",
  "nimphomania",
  "nipple",
  "nipples",
  "nsfw images",
  "nude",
  "nudity",
  "nympho",
  "nymphomania",
  "octopussy",
  "omorashi",
  "one cup two girls",
  "one guy one jar",
  "orgasm",
  "orgy",
  "paedophile",
  "paki",
  "panties",
  "panty",
  "pedobear",
  "pedophile",
  "pegging",
  "penis",
  "phone sex",
  "piece of shit",
  "pissing",
  "piss pig",
  "pisspig",
  "playboy",
  "pleasure chest",
  "pole smoker",
  "ponyplay",
  "poontang",
  "punany",
  "poop chute",
  "poopchute",
  "porn",
  "porno",
  "pornography",
  "prince albert piercing",
  "pubes",
  "pussy",
  "queaf",
  "queef",
  "quim",
  "raghead",
  "raging boner",
  "raping",
  "rapist",
  "rectum",
  "reverse cowgirl",
  "rimjob",
  "rimming",
  "rosy palm",
  "rosy palm and her 5 sisters",
  "rusty trombone",
  "sadism",
  "santorum",
  "schlong",
  "scissoring",
  "semen",
  "shaved beaver",
  "shaved pussy",
  "shemale",
  "shibari",
  "shit",
  "shitblimp",
  "shitty",
  "shota",
  "shrimping",
  "skeet",
  "slanteye",
  "slut",
  "s&m",
  "smut",
  "snatch",
  "snowballing",
  "sodomize",
  "sodomy",
  "splooge",
  "splooge moose",
  "spooge",
  "spread legs",
  "spunk",
  "strap on",
  "strapon",
  "strappado",
  "strip club",
  "style doggy",
  "suck",
  "sucks",
  "suicide girls",
  "sultry women",
  "swastika",
  "swinger",
  "tainted love",
  "taste my",
  "tea bagging",
  "threesome",
  "throating",
  "tied up",
  "tight white",
  "tits",
  "titties",
  "titty",
  "tongue in a",
  "topless",
  "tosser",
  "towelhead",
  "tranny",
  "tribadism",
  "tub girl",
  "tubgirl",
  "tushy",
  "twat",
  "twink",
  "twinkie",
  "two girls one cup",
  "undressing",
  "upskirt",
  "urethra play",
  "urophilia",
  "vagina",
  "venus mound",
  "vibrator",
  "violet wand",
  "vorarephilia",
  "voyeur",
  "vulva",
  "wank",
  "wetback",
  "wet dream",
  "white power",
  "wrapping men",
  "wrinkled starfish",
  "yaoi",
  "yellow showers",
  "yiffy",
  "zoophilia",
  "küss meinen arsch",
  "was zur hölle",
  "你真是一个废物",
  "你真烦人",
  "13点",
  "chutiya",
  "चुटिया"
]

export default badWords
